import { render } from "./UserMenu.vue?vue&type=template&id=044f39c5&scoped=true"
import script from "./UserMenu.vue?vue&type=script&lang=js"
export * from "./UserMenu.vue?vue&type=script&lang=js"

import "./UserMenu.vue?vue&type=style&index=0&id=044f39c5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-044f39c5"

export default script